// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyC6wf090A1sJ0bIMitcqXbpI9dfh3x752g",
    authDomain: "happy-math-education.firebaseapp.com",
    projectId: "happy-math-education",
    storageBucket: "happy-math-education.firebasestorage.app",
    messagingSenderId: "594037424888",
    appId: "1:594037424888:web:80af39cb5c937f7878b10d",
    measurementId: "G-9W3MVEGE8F"
};

const app = initializeApp(firebaseConfig);
getAnalytics(app);

export const auth = getAuth(app);
export const db = getFirestore(app);